import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getSupportedFieldConfiguration } from '../../../../../../../../../controllers/view-configuration';
import { VALID_RESULT } from './constants';
import { filterInvalidResults, isFieldPropertyName, prepareValidationResult } from './utils';
export var validateFieldChanges = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var fieldType, fieldId, currentField, fieldFromIframe, fieldMetadata, viewType, createAnalyticsEvent, fieldConfiguration, fieldValidators, validatorsArray, fieldValidationResults, invalidValidationResult;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          fieldType = _ref.fieldType, fieldId = _ref.fieldId, currentField = _ref.currentField, fieldFromIframe = _ref.fieldFromIframe, fieldMetadata = _ref.fieldMetadata, viewType = _ref.viewType, createAnalyticsEvent = _ref.createAnalyticsEvent;
          fieldConfiguration = getSupportedFieldConfiguration(viewType, fieldType);
          fieldValidators = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.publicShapeValidators;
          if (!(!fieldFromIframe || !fieldValidators)) {
            _context2.next = 5;
            break;
          }
          return _context2.abrupt("return", VALID_RESULT);
        case 5:
          validatorsArray = Object.entries(fieldValidators);
          _context2.next = 8;
          return Promise.all(validatorsArray.map( /*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
              var _ref5, propertyName, validate, propertyValue, validationResult;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _ref5 = _slicedToArray(_ref3, 2), propertyName = _ref5[0], validate = _ref5[1];
                    if (!isFieldPropertyName(fieldFromIframe, propertyName)) {
                      _context.next = 7;
                      break;
                    }
                    propertyValue = fieldFromIframe[propertyName];
                    _context.next = 5;
                    return validate(propertyValue, fieldMetadata, createAnalyticsEvent, {
                      currentField: currentField,
                      viewType: viewType
                    });
                  case 5:
                    validationResult = _context.sent;
                    return _context.abrupt("return", prepareValidationResult({
                      validationResult: validationResult,
                      fieldId: fieldId,
                      fieldType: fieldType,
                      propertyName: propertyName
                    }));
                  case 7:
                    return _context.abrupt("return", VALID_RESULT);
                  case 8:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x2) {
              return _ref4.apply(this, arguments);
            };
          }()));
        case 8:
          fieldValidationResults = _context2.sent;
          invalidValidationResult = filterInvalidResults(fieldValidationResults);
          if (!(invalidValidationResult.length > 0)) {
            _context2.next = 12;
            break;
          }
          return _context2.abrupt("return", {
            isValid: false,
            errors: invalidValidationResult.map(function (result) {
              return result.error;
            })
          });
        case 12:
          return _context2.abrupt("return", VALID_RESULT);
        case 13:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function validateFieldChanges(_x) {
    return _ref2.apply(this, arguments);
  };
}();